module.exports = __webpack_public_path__ + "img/icon_file_add.432816cf.svg";